import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const Instruction = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={[
        {
          m: 2,
          p: 3,
        },
        (theme) => ({
          backgroundColor: theme.palette.grey[100],
          borderRadius: theme.spacing(1),
        }),
      ]}
    >
      <Typography
        sx={{
          textAlign: 'center',
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};
